/**
 * @version 1.0
 * @author xieyq
 * @createTime 2021/8/17
 * @updateTime 2021/8/17
 * @decription 我的保全申请模块入口js
 */
import config from '../../../api/config'
// 标题栏
import acTitleBar from '@/components/app/title-bar/index.vue';
// 公共组件-按钮列表组件
import ccButtonList from '../../../components/common/button-list/index.vue';
import {Dialog} from 'vant';
import {
    typeBqlb,
    typeBqlx,
    typeBqzt
} from '@/filters/index';
import {SQBQ_BTN_TYPE, SQBQ_TYPE_MAP, SQBQ_SHOW_BTN_LIST} from '@/utils/consts';
import {getToken} from '@/utils/auth';
// 请求js
import request from './request.js';
// 按钮操作js
import btnAction from './btn-action.js';
import {getJcInit,getXxInit} from "@/api/guarantee";

export default {
    mixins: [request, btnAction],
    data() {
        return {
            keyWord: "", // 搜索关键字
            total: 0, // 保全总数
            list: [],
            loading: false, // 列表加载状态
            finished: false, // 是否列表全部加载完成
            page: 0, // 页码
            size: 10, // 每页尺寸, 固定不会改变
            btnType: SQBQ_BTN_TYPE,
            smallPro: "",
            // 嵌入在线服务新增——顶部tab导航数据
            tabNavList: [
                {id: 'bqsq', name: '保全申请'},
                {id: 'fysq', name: '复议申请'},
                {id: 'jbsq', name: '解保申请'},
                {id: 'xbsq', name: '续保申请'}
            ],
            // 嵌入在线服务新增——当前tab导航标识
            currentTabNav: 'bqsq',
            // 嵌入在线服务新增——是否显示选择申请类型弹层
            showApplyTypePicker: false,
            // 嵌入在线服务新增——申请类型下拉列表
            applyTypeList: [
                { text: '立即申请', value: '1' },
                { text: '申请复议', value: '2' }
            ]
        }
    },
    components: {
        acTitleBar,
        ccButtonList
    },
    methods: {

        /**
         * @function
         * @description 嵌入在线保全新增交互——点击申请保全按钮
         * @return {undefined} 无返回值
         */
        clickApply() {
            this.$router.push({
                path: '/preservationNotice'
            });
        },

        /**
         * @function
         * @description 嵌入在线保全新增交互——点击申请保全，弹选择弹层
         * @return {undefined} 无返回值
         */
        openApplyTypePicker() {
            this.showApplyTypePicker = true;
        },

        /**
         * @function
         * @description 嵌入在线保全新增交互——跳转申请页面
         * @param {object} item 选中对象数据
         * @return {undefined} 无返回值
         */
        toApplyPage(item) {
            if (item.value === '1') {
                // 申请保全
                this.$router.push({
                    path: '/preservationNotice'
                });
            } else if (item.value === '2') {
                // 申请复议
                this.$router.push({
                    path: '/reconsiderBasic'
                });
            }
        },

        /**
         * @function
         * @description 点击顶部tab导航
         * @param {*} item 当前点击对象数据
         * @return {undefined} 无返回值
         */
        changeTabNav(item) {
            this.currentTabNav = item.id;
            switch (this.currentTabNav) {
                // 保全申请
                case 'bqsq':
                    this.$router.push("/home/myPreservation");
                    break;
                // 复议申请
                case 'fysq':
                    this.$router.push("/home/myReconsider");
                    break;
                // 解保申请
                case 'jbsq':
                    this.$router.push("/home/myRelievPreservation");
                    break;
                // 续保申请
                case 'xbsq':
                    this.$router.push("/home/myContinuationPreservation");
                    break;
                default:
                    break;
            }
        },

        // 点击返回
        back() {
            // 返回到我的申请里面
            this.$router.push('/home/myApply');
        },
        //刷新页面
        refresh(){
           // window.location.reload();
            this.loadData();
        },
        //跳转详情
        goDetail(obj) {
            let {cId,cBqlx,cBqlb, btnList}=obj;
            if(btnList.indexOf(14)>-1){
                this.$router.push({
                    path: '/preservationDetail',
                    query:{
                        bqlx: cBqlx,
                        bqlb: cBqlb,
                        // 保全id
                        bqid: cId,
                        // 担保情况
                        dbqk: obj.cDbqk
                    }
                })
            }
        },
        isWeixn() {
            var ua = navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger/i) == "micromessenger") {
                return this.smallPro = true;
            } else {
                return this.smallPro = false;
            }
        },
        loadData() {
            this.loading = true;
            this.$axios.get("ssbq/api/xcx/yzwxcxbqsqs?page=" + ++this.page + "&rows=" + this.size + "&searchValue=" + encodeURI(this.keyWord))
                .then(res => {
                    let data = res.data;
                    this.total = data.total;
                    let list = data.list;
                    for (let db of list) {
                        let temp = {
                            cId: db.cId,
                            cBqlx:db.cBqlx,
                            cBqlb:db.cBqlb,
                            cBqlxTxt: typeBqlx(db.cBqlx), // 保全类型
                            cBqlbTxt: typeBqlb(db.cBqlb), // 保全类别
                            cBqzt: typeBqzt(db.cBqzt), // 保全状态
                            cSqrxm: db.cSqrxm, // 申请人姓名
                            cDsrxm: db.cDsrxm, // 当事人姓名
                            cSqdyfymc: db.cSqdyfymc, // 申请法院名称
                            nSqbqje: db.nSqbqje, // 申请保全金额
                            nJfje: db.nJfje, // 缴费金额
                            nSqbqdcsfy: db.nSqbqdcsfy, // 建议保全费
                            cSqbh: db.cSqbh,
                            // 担保情况
                            cDbqk: db.cDbqk,
                            // 针对财产保全  show48 false 返回旧的解除和续行 如果是true 就返回新版的解除和续行
                            show48: db.show48,
                            btnList: [], // 要展示的按钮
                            // 按钮数据信息项
                            btnDatas: []
                        };
                        // 显示的按钮
                        if (db.showBtn) {
                            // 按钮列表为逗号分割
                            temp.btnList = db.showBtn.split(",").map(Number);
                            // 转化为按钮对象
                            temp.btnList.forEach((btnItem) => {
                                // 如果申请保全中显示按钮列表，则按钮数据中填入对应的按钮对象
                                if (SQBQ_SHOW_BTN_LIST.indexOf(btnItem) > -1) {
                                    temp.btnDatas.push(SQBQ_TYPE_MAP[btnItem]);
                                }
                            })
                        }
                        this.list.push(temp);
                    }
                    if (this.page * this.size >= this.total) {
                        // 数据全部加载完成, 接口返回的totalPage为空, 采用另一种方法判断
                        this.finished = true;
                    }
                    // 加载状态结束
                    this.loading = false;
                });
        },
        onSearch: function () {
            // 搜索时重置页数和数据
            this.page = 0;
            this.list = [];
            // 需要重置finished值
            this.finished = false;
            // 加载数据
            this.loadData();
        },
        /**
         * 按钮点击事件
         * @param {Object} btnItem 按钮信息项
         * @param {Object} dataItem 数据信息项
         * @returns {void}
         * */
        async eClickBtn(btnItem, dataItem) {
            sessionStorage.setItem('cBqlx', dataItem.cBqlx);
            sessionStorage.setItem('cBqlb', dataItem.cBqlb);
            sessionStorage.setItem('show48', dataItem.show48);
            sessionStorage.setItem('bqid', dataItem.cId);
            if (btnItem.key && btnItem.key == 'jcbq') {
               await getJcInit({bqid: dataItem.cId}).then((res) => {
                    sessionStorage.setItem('cId', res.data.cId);
                    sessionStorage.setItem('jcInitData', JSON.stringify(res))
                })
            }
            if (btnItem.key && btnItem.key == 'xxbq') {
                await getXxInit({bqid: dataItem.cId}).then((res) => {
                    sessionStorage.setItem('cId', res.data.cId);
                    sessionStorage.setItem('xxInitData', JSON.stringify(res))
                })
            }
            // 如果存在对应的事件方法，则直接执行对应的事件方法
            if (btnItem.key && this[`ba_${btnItem.key}`]) {
                // 对应btn-action.js中的方法
                this[`ba_${btnItem.key}`](btnItem, dataItem);
                return;
            }
            // TODO 暂时用对应的事件方法，后续进行优化
            this.onBtnClick(btnItem.type, dataItem.cId, dataItem.cSqbh, dataItem.cSqrxm);
        },
        onBtnClick: function (type, id, cSqbh, sqrXm) {
            // 编辑
            if (type === this.btnType.BJ_BUTTON) {
                // 编辑
                sessionStorage.setItem("currentBqid", JSON.stringify(id));
                this.$router.push("/preservationInfo");
                return;
            }
            // 删除
            if (type === this.btnType.SC_BUTTON) {
                // 删除
                Dialog.confirm({
                    title: '提示',
                    message: '此操作将永久删除该条记录, 是否继续?',
                    confirmButtonColor: '#ffffff',
                    cancelButtonColor: '#ffffff'
                }).then(() => {
                    this.$axios.delete("ssbq/api/bqsq/logic?id=" + id).then(res => {
                        if (res.code === 204) {
                            this.$notify({
                                message: "删除成功",
                                type: "success"
                            });
                            this.page = 0;
                            this.list = [];
                            this.loadData();
                        }
                    });
                }).catch(() => {
                });
                return;
            }
            if (type === this.btnType.BCCL_BUTTON) {
                sessionStorage.setItem("currentBqid", JSON.stringify(id));
                this.$router.push("/preservationInfo");
                return;
            }
            // 详情按钮
            if (type === this.btnType.XQ_BUTTON) {
                this.$router.push({
                    path: '/preservationDetail',
                    query:{
                        // 保全id
                        bqid: id
                    }
                })
                return;
            }
            if (type === this.btnType.QXBQ_BUTTON) {
                Dialog.confirm({
                    title: '提示',
                    message: '确定要取消保全吗?该记录取消后将不能恢复，如需申请保全，需重新创建。',
                    confirmButtonColor: '#ffffff',
                    cancelButtonColor: '#ffffff'
                }).then(() => {
                    this.$axios.put("ssbq/api/sqbq/qxbq?bqid=" + id)
                        .then(() => {
                            this.$notify({type: 'success', message: '取消保全成功'});
                            setTimeout(() => {
                                this.$router.go(0);
                            }, 500);
                        });
                }).catch(() => {
                });
            }
        }
    },
    created() {
        this.loadData();
        // this.isWeixn()
        // let _this = this
        // _this.ws = new WebSocket(`${config.ws_jf+getToken()}`);
        // _this.ws.onmessage = function (e) {
        //     console.log("WebSocket链接===",e)
        //     _this.loadData()
        //     window.location.reload();
        //     _this.ws.onclose = function () {
        //         console.log("client：关闭连接");
        //     };
        // };
    },
    mounted(){
        var hiddenProperty = 'hidden' in document ? 'hidden' : 'webkitHidden' in document ? 'webkitHidden' : 'mozHidden' in document ? 'mozHidden' : null;
        console.log(hiddenProperty);
        document.addEventListener('visibilitychange', () => {
            if (document[hiddenProperty]) {
                //当离开H5 跳转到app原生的页面时,这里会被触发
                console.log('页面隐藏了');
            } else {
                //当从原生页面用户一系列操作后,返回H5的时候,这里会被触发
                console.log('页面展示了');
                //强制刷新页面 待交费 =》 已交费
                location.reload();
            }
        });
    },
    beforeDestroy() {
        let _this = this
        if(_this.ws){
            _this.ws.onclose = function () {
                console.log("client：关闭连接");
            };
        }
    }
};

